// extracted by mini-css-extract-plugin
export default {"runButton":"runTestCasesButton_runButton__9OXqt","cancelButton":"runTestCasesButton_cancelButton__dxcXB"};